module.exports = __webpack_public_path__ + "static/media/PaymentsIcon_grey.e663c5ba.svg";